<template>
  <div class="home-page">
    <transition name="fade">
      <Xk v-if="!isVisible" />
    </transition>
    <Flow v-if="isVisible" />

    <div class="main">
      <img
        src="@/assets/home/header.png"
        alt=""
        class="header-icon scroll-fade"
      />
      <div class="go-buy" @click="goMarket">{{ t("home.goBuy") }}</div>
      <div class="link-main scroll-fade">
        <img
          src="@/assets/home/tt.png"
          alt=""
          class="tt-icon"
          @click="goPathUrl('x')"
        />
        <img
          src="@/assets/home/d.png"
          alt=""
          class="d-icon"
          @click="goPathUrl('dis')"
        />
        <img
          src="@/assets/home/ins.png"
          alt=""
          class="ins-icon"
          @click="goPathUrl('ins')"
        />
        <img
          src="@/assets/home/tg.png"
          alt=""
          class="ins-icon margin-left-two"
          @click="goPathUrl('tg')"
        />
      </div>
      <div class="title scroll-fade">{{ t("home.title") }}</div>
      <div class="sub-title scroll-fade">{{ t("home.subTitle") }}</div>
      <div class="info scroll-fade">{{ t("home.info") }}</div>
      <div class="our-series scroll-fade">{{ t("home.ourSeries") }}</div>
      <div class="list-item scroll-fade">
        <template v-for="item in projectList">
          <div
            class="item"
            v-if="item.id === '1876926030669729794'"
            :key="item.id"
            @click="goChild"
          >
            <!-- :style="{ 'background-image': `url(${item.imageResource.url})` }" -->
            <img class="item-img" :src="item.imageResource.url" alt="" />
            <div class="item-bg"></div>
            <div class="block">
              <div class="time">{{ formatDate(item.publishTime) }}</div>
              <div class="name">{{ $t("home.iceAge") }}</div>
              <div class="nft">{{ $t("home.similarFate") }}</div>
            </div>
          </div>
          <div
            class="item"
            :style="{ 'background-image': `url(${item.imageResource.url})` }"
            v-else
            :key="item.id"
          >
            <img class="item-img" :src="item.imageResource.url" alt="" />
            <div class="item-bg"></div>
            <div class="block">
              <div class="time">{{ $t("home.comingSoon") }}</div>
              <div class="name">{{ $t("home.cretaceous") }}</div>
              <div class="nft">{{ $t("home.toBeSoon") }}</div>
            </div>
          </div>
        </template>
      </div>
      <!-- <div class="list-item scroll-fade">
        <div class="item item-1">
          <div class="item-bg"></div>
          <div class="block">
            <div class="time">{{ t("home.time") }}</div>
            <div class="name">{{ t("home.iceAge") }}</div>
            <div class="nft">{{ t("home.similarFate") }}</div>
          </div>
        </div>
        <div class="item item-2">
          <div class="item-bg"></div>
          <div class="block">
            <div class="time">{{ t("home.comingSoon") }}</div>
            <div class="name">{{ t("home.cretaceous") }}</div>
            <div class="nft">{{ t("home.toBeSoon") }}</div>
          </div>
        </div>
      </div> -->

      <div class="more scroll-fade">
        <img src="@/assets/home/bb.png" alt="" class="more-bg" />
      </div>

      <div class="fishbone scroll-fade">
        <img src="@/assets/home/fishbone.png" alt="" class="fishbone-img" />
        <img
          src="@/assets/mobile/fishbone.png"
          alt=""
          class="fishbone-mobile-img"
        />

        <div class="fishbone-item first">
          <div>{{ t("home.OfficialWebsiteRelease") }}</div>
          <div>{{ t("home.OfficialWebsiteReleaseTime") }}</div>
        </div>
        <div class="fishbone-item two">
          <div>{{ t("home.firstBatch") }}</div>
          <div>{{ t("home.toBeSoon") }}</div>
        </div>
        <div class="fishbone-item three">
          <div>{{ t("home.FreeMarketRelease") }}</div>
          <div>{{ t("home.toBeSoon") }}</div>
        </div>
        <div class="fishbone-item five">
          <div>{{ t("home.ChainTravel") }}</div>
          <div>{{ t("home.toBeSoon") }}</div>
        </div>
      </div>
      <div class="up scroll-fade">
        "NEVER GONNA GIVE YOU UP."
        <img src="@/assets/home/hua.png" alt="" class="hua-icon" />
      </div>

      <Footer></Footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Flow from "@/components/flow.vue";
import Footer from "@/components/footer.vue";
import Xk from "@/components/xk.vue";
import {
  visitorPvApi,
  xUrlApi,
  tgUrlApi,
  insUrlApi,
  disUrlApi,
} from "@/api/other";
import { nftApi } from "@/api/nft";

// 接口定义
interface ApiResponse<T = any> {
  code: number;
  data: T;
  message?: string;
}

interface ProjectItem {
  id: string;
  name: string;
  imageResource?: {
    url: string;
  };
}

const router = useRouter();
const { t } = useI18n();

const formatDate = (dateString: string) => {
  if (!dateString) return "";
  return dateString.split("-").slice(0, 2).join("-");
};
// 响应式状态
const isVisible = ref(false);
const isAn = ref(true);
const projectList = ref<ProjectItem[]>([]);
let observer: IntersectionObserver | null = null;

// 获取项目列表
const getProject = async () => {
  try {
    const res = await nftApi.getProjects();
    if (res.code === 200) {
      projectList.value = res.data;
    }
  } catch (error) {
    console.error("Failed to fetch projects:", error);
  }
};
// 跳转购买
const goMarket = () => {
  router.push({ path: "/market", query: {} });
};
// 社交媒体跳转
const goPathUrl = async (type: string) => {
  let api;
  switch (type) {
    case "tg":
      api = tgUrlApi;
      break;
    case "dis":
      api = disUrlApi;
      break;
    case "ins":
      api = insUrlApi;
      break;
    case "x":
      api = xUrlApi;
      break;
  }

  if (api) {
    try {
      const res = await api();
      if (res.code === 200 && res.data) {
        window.location.href = res.data as string;
      }
    } catch (error) {
      console.error(`Failed to fetch ${type} URL:`, error);
    }
  }
};
const goChild = () => {
  router.push({ path: "/child", query: {} });
};
// 初始化滚动动画
const initScrollAnimation = () => {
  const scrollElements = document.querySelectorAll(".scroll-fade");

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in");
        } else {
          entry.target.classList.remove("fade-in");
        }
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    }
  );

  scrollElements.forEach((el) => {
    observer?.observe(el);
  });
};

// 访客统计
const recordVisit = async (sessionId: string) => {
  try {
    await visitorPvApi(sessionId);
  } catch (error) {
    console.error("Failed to record visit:", error);
  }
};

// 生命周期钩子
onMounted(() => {
  window.scrollTo(0, 0);

  setTimeout(() => {
    isVisible.value = !isVisible.value;
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      recordVisit(sessionId);
    }
  }, 3000);

  initScrollAnimation();
  getProject(); // 获取项目列表
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped lang="scss">
.home-page {
  /* background:radial-gradient(50% 50% at 0% 0%,#183c6f 26%,#05091e 100%);*/
  width: 100%;
  box-sizing: border-box;
  /* min-height:100vh;*/
  min-height: 100vh;
  position: relative;
  overflow-y: auto;
  // 添加动画相关样式
  .scroll-fade {
    opacity: 0;
    transform: translateY(3.125rem);
    transition: all 1s ease-out;
    will-change: opacity, transform;
    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .main {
    background-image: url("@/assets/home/bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 16.75rem;
    .header-icon {
      display: block;
      margin: 0 auto;
      width: 40.875rem;
      height: 29.25rem;
      /* margin-top:10.875rem;*/
    }
    .go-buy {
      display: none;
    }
    .link-main {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 7.1875rem;
      .tt-icon {
        width: 3rem;
        height: 3rem;
      }
      .d-icon {
        width: 3rem;
        height: 3rem;
        margin: 0 2rem;
      }
      .ins-icon {
        width: 3rem;
        height: 3rem;
      }
      .margin-left-two {
        margin-left: 2rem;
      }
    }
    .title {
      margin-top: 18.5625rem;
      font-size: 1.625rem;
      color: #fefefe;
      text-align: center;
      font-family: FCH;
      font-weight: bold;
    }
    .sub-title {
      width: 45.6875rem;
      text-align: center;
      margin: 2.25rem auto 0 auto;
      font-size: 1.5rem;
      color: #ffffff;
      font-family: FCH;
      /* font-weight:bold;*/
    }
    .info {
      margin: 4.5rem auto 0 auto;
      width: 68.125rem;
      height: 28rem;
      line-height: 2rem;
      padding: 5.0625rem 4.4375rem 5.3125rem 4.4375rem;
      background-image: url("@/assets/home/txt.png");
      background-size: 100%;
      background-repeat: no-repeat;
      font-size: 1.25rem;
      color: #ffffff;
      text-align: center;
      font-family: FCH;
    }
    .our-series {
      font-family: FCH;
      font-size: 1.625rem;
      color: #ffffff;
      margin-top: 20.75rem;
      text-align: center;
    }
    .list-item {
      /* display: flex;
        align-content: center;
        justify-content: center; */
      width: 68.125rem;
      display: grid;
      /* gap: 2.3125rem; */
      grid-template-rows: 1fr;
      margin: 0rem auto;
      grid-template-columns: repeat(2, 1fr);
      justify-content: center;
      margin-top: 3.25rem;
      .item {
        margin: 0 1.25rem;
        width: 32.5rem;
        height: 20.5625rem;
        /* border-radius:0.3125rem;*/
        position: relative;
        background-size: 100%;
        background-repeat: no-repeat;
        transition: background-size 0.5s ease;
        background-position: center;
        overflow: hidden;
        .item-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease;
        }
        .item-bg {
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
        }
        .block {
          padding: 1.875rem;
          z-index: 3;
          position: relative;
          .time {
            font-size: 1.625rem;
            color: #ffffff;
            font-family: FCH;
            z-index: 2;
          }
          .name {
            font-size: 1.625rem;
            color: #ffffff;
            font-family: FCH;
            margin-top: 0.625rem;
            z-index: 2;
          }
          .nft {
            font-size: 1.25rem;
            color: #ffffff;
            margin-top: 1.5625rem;
            font-family: FCH;
            z-index: 2;
          }
        }
      }
      .item-1 {
        background-image: url("@/assets/home/item3.png");
      }
      .item-2 {
        background-image: url("@/assets/home/item3.png");
      }
      .item:hover {
        background-size: 120%;
        .item-img {
          transform: scale(1.2);
        }
      }
    }
    .more {
      margin: 0 auto;
      margin-top: 2.1875rem;
      width: 67.5rem;
      height: 24.25rem;
      //background-color: #4e657f;
      border-radius: 0.625rem;
      padding: 2.6875rem 1.625rem;
      font-family: FCH;
      //background-image: url("@/assets/home/project_beanz.png");
      //background-size: 100%;
      //background-repeat: no-repeat;
      position: relative;
      .more-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 67.5rem;
        height: 24.25rem;
        object-fit: fill;
        z-index: 1;
      }
      .more-title {
        z-index: 2;
        font-size: 1.625rem;
        color: #ffffff;
        position: relative;
      }
      .more-item {
        position: relative;
        z-index: 2;
        font-size: 1.625rem;
        color: #ffffff;
      }
    }
    .more-icon {
      margin: 2.1875rem auto 0 auto;
      width: 67.5rem;
      display: block;
    }
    .fishbone {
      margin: 0 auto;
      margin-top: 17.1875rem;
      width: 101rem;
      height: 38rem;
      position: relative;
      .fishbone-title {
        width: 100%;
        text-align: center;
        font-size: 1.625rem;
        color: #ffffff;
        font-family: FCH;
      }
      .fishbone-img {
        margin-top: 2rem;
        width: 101rem;
        height: 33rem;
      }
      .fishbone-mobile-img {
        display: none;
      }
      .fishbone-item {
        position: absolute;
        font-size: 1.25rem;
        color: #ffffff;
        text-align: center;
        font-family: FCH;
        font-weight: bold;
      }
      .first {
        width: 16rem;
        top: 7rem;
        left: 17rem;
        text-align: center;
      }
      .two {
        width: 16rem;
        left: 29.4rem;
        bottom: 6rem;
      }
      .three {
        width: 16rem;
        right: 28rem;
        bottom: 3rem;
      }
      .five {
        width: 16rem;
        right: 13.4rem;
        bottom: 15rem;
      }
    }
    .up {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 32rem;
      font-size: 2.88rem;
      color: #ffffff;
      font-family: DFP;
      .hua-icon {
        margin-left: 1rem;
        width: 2rem;
        height: 3rem;
      }
    }
  }
  @keyframes fall {
    0% {
      top: -100px; /* 图片从视窗顶部之外开始 */
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      top: 100vh; /* 掉落到视窗底部 */
      opacity: 0;
    }
  }

  .image {
    width: 2.5rem;
    height: 2.5rem;
    position: fixed;
    top: -6.25rem;
    /* 起始位置在视窗顶部之外*/
    left: 50%;
    /* 初始水平居中，实际会被随机覆盖*/
    transform: translateX(-50%);
    animation: fall 3s linear infinite;
    /* 默认动画*/
    z-index: 100;
  }

  .fall-animation {
    position: fixed;
    top: -100px; /* 起始位置 */
    left: 50%; /* 初始水平居中 */
    transform: translateX(-50%);
    animation: fall 3s linear infinite;
  }
}

@media (max-width: 750px) {
  .home-page {
    width: 100%;
    box-sizing: border-box;
    height: 100vh;
    position: relative;
    overflow-y: auto;
    // 添加动画相关样式
    .scroll-fade {
      opacity: 0;
      transform: translateY(3.125rem);
      transition: all 1s ease-out;
      will-change: opacity, transform;

      &.fade-in {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .main {
      padding-top: 210px !important;
      background-image: url("@/assets/mobile/bg.png");
      background-size: cover;
      background-repeat: no-repeat;
      .header-icon {
        display: block;
        margin: 0 auto;
        width: 274px !important;
        height: 169px !important;
      }
      .go-buy {
        display: block;
        width: 116px;
        height: 37px;
        background-image: url("@/assets/mobile/buy.png");
        background-size: cover;
        background-repeat: no-repeat;
        font-family: FCH;
        font-size: 15px;
        color: #ffffff;
        text-align: center;
        margin: 57px auto;
        line-height: 37px;
      }
      .link-main {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0px !important;
        .tt-icon {
          width: 22px !important;
          height: 22px !important;
        }
        .d-icon {
          width: 22px !important;
          height: 22px !important;
          margin: 0 35px !important;
        }
        .ins-icon {
          width: 22px !important;
          height: 22px !important;
        }
        .margin-left-two {
          margin-left: 35px;
        }
      }
      .title {
        width: 180px;
        margin: 0 auto;
        margin-top: 106px;
        font-size: 14px;
        color: #fefefe;
        text-align: center;
        font-family: FCH;
        font-weight: bold;
      }
      .sub-title {
        width: 284px;
        font-family: FCH;
        font-size: 11px;
        color: #ffffff;
        text-align: center;
        line-height: 14px;
        margin: 25px auto 0 auto;
      }
      .info {
        width: 333px;
        height: 310px;
        background-image: url("@/assets/mobile/txt.png");
        background-size: cover;
        background-repeat: no-repeat;
        margin: 22px auto 0 auto;
        font-size: 12px;
        color: #ffffff;
        line-height: 16px;
        text-align: center;
        font-family: FCH;
        padding: 29px 22px;
      }
      .our-series {
        font-family: FCH;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        margin-top: 51px;
      }
      .list-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .item {
          width: 329px;
          height: 183px;
          margin-top: 24px;

          .block {
            padding: 15px 17px;
            .time {
              font-family: FCH;
              font-size: 12px;
              color: #ffffff;
            }
            .name {
              font-family: FCH;
              font-size: 12px;
              color: #ffffff;
              margin: 5px 0 10px 0;
            }
            .nft {
              font-family: FCH;
              font-size: 11px;
              color: #ffffff;
            }
          }
        }
        .item-1 {
        }
        .item-2 {
        }
      }
      .more {
        width: 329px;
        height: 114px;
        border-radius: 5px;
        //background-color: #4e657f;
        padding: 22px 19px;
        margin-top: 24px;
        position: relative;
        .more-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 329px;
          height: 114px;
          object-fit: fill;
          z-index: 1;
        }
        .more-title {
          position: relative;
          z-index: 2;
          ont-family: FCH;
          font-size: 12px;
          color: #ffffff;
        }
        .more-item {
          position: relative;
          z-index: 2;
          ont-family: FCH;
          font-size: 12px;
          color: #ffffff;
          margin-top: 10px;
        }
      }
      .more-icon {
        margin: 24px auto 0 auto;
        display: block;
        width: 329px;
        border-radius: 5px;
      }
      .fishbone {
        width: 100%;
        height: 221px;
        margin: 56px auto 0 auto !important;
        position: relative;
        .fishbone-title {
          width: 100%;
          text-align: center;
          font-family: FCH;
          font-size: 14px;
          color: #ffffff;
        }
        .fishbone-img {
          //margin-top: 2rem;
          width: 370px;
          height: 147px;
          display: none;
          //display: none;
        }
        .fishbone-mobile-img {
          width: 370px;
          height: 147px;
          display: block;
          margin: 0 auto;
        }
        .fishbone-item {
          position: absolute;
          font-family: FCH;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
        }
        .first {
          width: 120px;
          top: 25px;
          left: 0px;
        }
        .two {
          width: 130px;
          bottom: 56px;
          left: 58px;
        }
        .three {
          width: 130px;
          right: 64px;
          bottom: 40px;
        }
        .five {
          width: 120px;
          right: 0px;
          bottom: 98px;
        }
      }

      .up {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 110px;
        font-size: 20px;
        color: #ffffff;
        font-family: DFP;
        .hua-icon {
          margin-left: 12px;
          width: 21px;
          height: 25px;
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease; /* 设置过渡效果 */
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在 Vue 2 中 */ {
  opacity: 0; /* 隐藏时的透明度 */
}
</style>
  